import { IPagedResultsV1 } from '@gcl/react-core';
import { envConfigs } from '@config/envConfigs';
import { apiServerDelete, apiServerGet, apiServerPut } from '@common/axios.services';
import {
  IDeleteProjectMasterScheduleTagRequest,
  IProjectMasterScheduleTagBase,
  IProjectMasterScheduleTagsSearchRequest,
  IUpdateProjectMasterScheduleTagRequest,
} from './masterScheduleTag.models';

export const apiRoutes = {
  projectMasterScheduleTagsSearch: '/ProjectMasterScheduleTags/Search',
  projectMasterScheduleTags: '/ProjectMasterScheduleTags',
};

export const getProjectMasterScheduleTagsSearchAsync = async (
  request: IProjectMasterScheduleTagsSearchRequest,
): Promise<IPagedResultsV1<IProjectMasterScheduleTagBase>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectMasterScheduleTagBase>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.projectMasterScheduleTagsSearch}`,
    {
      params: {
        ...request,
      },
    },
  );
  return result.data;
};

export const putProjectMasterScheduleTagsSearchAsync = async (
  request: IUpdateProjectMasterScheduleTagRequest,
): Promise<IPagedResultsV1<IProjectMasterScheduleTagBase>> => {
  const result = await apiServerPut<IPagedResultsV1<IProjectMasterScheduleTagBase>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.projectMasterScheduleTags}`,
    request,
  );
  return result.data;
};

export const deleteProjectMasterScheduleTagsSearchAsync = async (
  request: IDeleteProjectMasterScheduleTagRequest,
): Promise<boolean> => {
  const result = await apiServerDelete<boolean>(`${envConfigs.apiBaseUrl}${apiRoutes.projectMasterScheduleTags}`, {
    params: {
      ...request,
    },
  });
  return result.data;
};
